import React from 'react'
import "./SubStyle.css"

const Soft_Allowances = () => {
 const points = [
   "Plant and Machinery",
   "Integral Features",
   "Special Rate Assets",
   "Main Pool Assets",
   "Structures and Buildings Allowance (SBA)",
   "Annual Investment Allowance (AIA)",
   ]

   const points2 = [
    "Capital allowance schedules",
    "Writing Down Allowances",
    "First Year Allowances",
    "Annual Investment Allowance calculations",
    "Balancing adjustments",
    
   ]



   const points3 = [
    "Commercial Properties",
    "Care Homes",
    "Hotels",
    "Industrial Units",
    "Retail Premises",
    "Offices",
    "Mixed-Use Developments",
   ]

  const points4 = [
    "Tax savings achieved",
    "Qualifying expenditure identified",
    "Claim calculations",
    "HMRC-ready supporting information",
  ]




  return (
    <>
       <section className="Allowances-section">
      <div className="Allowances-container">
        <h2 className="Allowances-title">Capital Allowance Software for Accountants</h2>
      </div>
    </section>

    <section className="Sub-section">
      <div className="Sub-container">
        <div className='Sub-Cue'>
          <h3 className='Sub-title'>Faster Calculations. Greater Accuracy. Better Client Outcomes.</h3>
          <p>Our Capital Allowance Software has been designed specifically for accountants, tax advisers, and 
            capital allowance specialists who need a quicker, more efficient way to identify and calculate capital 
            allowance claims.</p>
            <p>Whether you are reviewing commercial property acquisitions, refurbishments, or existing property
               portfolios, our software simplifies the process, reducing the time spent on manual calculations
                while helping to maximise tax relief opportunities for your clients.</p>
        </div>

        <div className='Sub-Cue'>
          <h3 className='Sub-title'>Why Accountants Choose Our Software Save Hours on Every Claim</h3>
          <p>Eliminate complex spreadsheets and manual calculations. Generate capital allowance assessments in minutes rather than days.</p>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Improve Accuracy</h3>
          <p>Built-in calculation engines help ensure claims are prepared consistently and accurately, reducing the risk of errors and omissions</p>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Identify Missed Tax Relief</h3>
          <p>Quickly analyse qualifying expenditure and uncover capital allowance opportunities that may otherwise be overlooked.</p>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Increase Capacity</h3>
          <p>Handle more client projects without increasing staff workload, allowing your team to focus on advisory services and business growth.</p>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Standardised Reporting</h3>
          <p>Produce professional reports and supporting schedules that can be used for client presentations, tax computations, and compliance documentation.</p>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Key Features Intelligent Asset Classification</h3>
          <p>Automatically categorise qualifying expenditure into the appropriate capital allowance pools, including:</p>
           <div className="Sub-bullet-container">
            <ul className="Sub-bullet-list">
              {points.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Automated Calculations</h3>
          <p>Generate:</p>
          <div className="Sub-bullet-container">
            <ul className="Sub-bullet-list">
              {points2.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Property-Based Assessments</h3>
          <p>Designed for accountants working with:</p>
           <div className="Sub-bullet-container">
            <ul className="Sub-bullet-list">
              {points3.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Client Reporting Suite</h3>
          <p>Create professional reports that clearly demonstrate:</p>
           <div className="Sub-bullet-container">
            <ul className="Sub-bullet-list">
              {points4.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Benefits for Your Practice Increase Revenue</h3>
          <p>Offer capital allowance reviews as a profitable additional service to existing clients.</p>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Improve Client Retention</h3>
          <p>Deliver valuable tax savings that strengthen client relationships and demonstrate proactive advice.</p>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Reduce Risk</h3>
          <p>Maintain consistency across all capital allowance reviews with a structured and auditable process.</p>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Scale Your Service Offering</h3>
          <p>Provide capital allowance assessments without requiring specialist in-house expertise on every project.</p>
        </div>

         <div className='Sub-Cue'>
          <h3 className='Sub-title'>Built for Modern Accountancy Practices</h3>
          <p>Our software combines automation, tax expertise, and practical reporting tools to help accountancy firms deliver <br/> capital 
            allowance claims more efficiently than ever before.</p>
            <p>Whether you manage a small portfolio of property-owning clients or a large commercial property client base,<br/> our 
              platform helps you maximise tax relief opportunities while reducing the time and cost involved in preparing claims.</p>

              <h3 className='Sub-title'>Discover how much time your practice could save. </h3>
              <p>Book a demonstration today and see how our Capital Allowance Software can transform the way your firm delivers capital allowance services.</p>
        </div>
      </div>
    </section>
    </>
  )
}

export default Soft_Allowances
